import React from 'react';

interface Props {
  width?: string;
  height?: string;
  className?: string;
}

const EgnyteOutline: React.FC<Props> = ({ width, height, className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd">
        <g fill="#4B575D" fillRule="nonzero">
          <g>
            <g>
              <g>
                <path
                  d="M7.922 7.264L2.535 3.294 0 5.163 6.411 9.886 6.427 9.907 6.427 17.333 9.433 17.333 9.433 9.886 15.842 5.163 13.312 3.292z"
                  transform="translate(-158 -407) translate(158 243) translate(0 164) translate(4 3)"
                />
                <path
                  d="M11.671 10.954L10.778 12.164 14.825 15.146 15.717 13.936zM8.683 0L7.179 0 7.179 5.026 8.683 5.026zM4.17 10.957L.125 13.939 1.018 15.15 5.063 12.167z"
                  transform="translate(-158 -407) translate(158 243) translate(0 164) translate(4 3)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default EgnyteOutline;
